import { useSelector } from 'react-redux';

export const useRole = () => {
  const roleData = useSelector(state => state.initialParams.role);

  return [roleData];
};

export default useRole;